// What a rep sees on console pages meant for admins and managers (WEB_PLAN.md §3.1): the console's value is
// management; a rep's map, visits, routes and pipeline live in the iPhone app.

import { ExternalLink, Smartphone } from 'lucide-react';
import { Link } from 'react-router';
import { env } from '@/env';
import { EmptyState } from '@/ui';

export function UseTheApp() {
  return (
    <div className="mx-auto flex min-h-full w-full max-w-3xl items-center px-6 py-10">
      <EmptyState
        icon={<Smartphone />}
        color="#F96A3C"
        title="Use the Ground Team app"
        message="This part of the console is for admins and managers. Your map, visits, routes and pipeline are in the Ground Team app on your iPhone. Here you can check your numbers, your stores, your follow-ups and the company documents."
        action={
          <>
            <Link
              to="/"
              className="inline-flex h-9 items-center rounded-control px-4 text-sm font-semibold gt-primary-fill text-primary-contrast shadow-primary"
            >
              My numbers
            </Link>
            <Link
              to="/stores"
              className="inline-flex h-9 items-center rounded-control border border-line-strong bg-surface px-4 text-sm font-semibold text-fg hover:bg-surface-2"
            >
              My stores
            </Link>
            <a
              href={env.appStoreUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex h-9 items-center gap-1.5 rounded-control px-3 text-sm font-semibold text-link hover:underline"
            >
              Get the app
              <ExternalLink aria-hidden className="size-3.5" />
            </a>
          </>
        }
      />
    </div>
  );
}
